import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { CalendarDays } from 'lucide-react';
import AssistantResource from 'Resources/AssistantChat';
import AppointmentResource from 'Resources/Appointment';
import logError from 'Helpers/logError';

type Meeting = { conversationId: number; description: string; date: Date | string };

// Shows which meeting an `appointment` chat (FEA-139) is about, so the rep can see the
// Assistant already knows it without naming it.
export default function MeetingContextPill({ conversationId }: { conversationId: number | null }) {
	const [meeting, setMeeting] = useState<Meeting | null>(null);

	useEffect(() => {
		if (conversationId === null) return;
		let cancelled = false;
		AssistantResource.getConversation(conversationId)
			.then(async conversation => {
				if (conversation.contextType !== 'appointment' || !conversation.contextId) return;
				const { data } = await AppointmentResource.get(conversation.contextId);
				if (!cancelled && data) {
					setMeeting({ conversationId, description: data.description, date: data.date });
				}
			})
			.catch(err => logError(err, 'MeetingContextPill: could not load the meeting'));
		return () => {
			cancelled = true;
		};
	}, [conversationId]);

	if (!meeting || meeting.conversationId !== conversationId) return null;

	return (
		<div className="floating-chat-context">
			<span className="floating-chat-context-pill">
				<CalendarDays aria-hidden />
				<strong>{meeting.description}</strong>
				<span>{`· ${moment(meeting.date).format('L')}`}</span>
			</span>
		</div>
	);
}
